import cookies from "js-cookie";

const baseUrl = process.env.VUE_APP_API_URL_BASE;
const cookieName = "access_token";

const showApiErrors = process.env.showApiErrors;

class RequestClient {
  async get(url) {
    const response = await this.baseRequest("GET", url);
    return JSON.parse(response);
  }

  async delete(url, data = {}) {
    const response = await this.baseRequest("DELETE", url, data);
    return response;
  }

  async post(url, data) {
    const response = await this.baseRequest("POST", url, data);
    return response ? JSON.parse(response) : response;
  }

  async patch(url, data) {
    const response = await this.baseRequest("PATCH", url, data);
    return response ? JSON.parse(response) : response;
  }

  baseRequest(method, url, data = {}) {
    const token = cookies.get(cookieName);
    const requestUrl = baseUrl + url;
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      xhr.open(method, requestUrl);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else if (showApiErrors && this.status === 400) {
          reject(new Error(`${xhr.responseText} Status code: ${xhr.status}`));
        } else {
          if (xhr.responseText) {
            let error;
            try {
              error = JSON.parse(xhr.responseText);
            } catch {
              error = null;
            }
            if (error?.message) {
              reject(error.message);
              return;
            }
          }
          reject(new Error(`An unexpected error occurred. Status code: ${xhr.status}`));
        }
      };
      xhr.onerror = function () {
        reject(Error(`An unexpected error occurred. Status code: ${xhr.status}`));
      };
      xhr.send(JSON.stringify(data));
    });
  }
}

export default new RequestClient();
